import * as React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { UserNotificationSettingsForm } from '../../../../userNotifications/components/settings/UserNotificationsSettingsForm';
import { UserNotificationSettingsLayer } from '../../../../userNotifications/models/UserNotificationSettingsLayer';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { SiteSettingsForSiteAdminProps } from '../ReactSiteSettingsForSiteAdmin';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';

export type UserNotificationsSiteSettingsSectionProps = SiteSettingsForSiteAdminProps<undefined>;

export function UserNotificationsSiteSettingsSection(props: UserNotificationsSiteSettingsSectionProps) {
  if (!FeatureFlags.userNotificationSettingsEnabled || props.createSite) {
    return null;
  }

  return (
    <SettingsSection
      title={renderTitle()}
      testId={'user-notifications-settings-section'}
      description={Messages.userNotificationSiteSettingsDescription()}
    >
      <UserNotificationSettingsForm layer={UserNotificationSettingsLayer.Site} siteId={props.siteId} />
    </SettingsSection>
  );
}

function renderTitle() {
  return <span>{Messages.userNotificationSiteOrServerSettingsLabel()}</span>;
}

export const UserNotificationsSiteSettingsSectionSpecs = componentRegistryEntry({
  name: 'UserNotificationsSiteSettingsSection',
  component: UserNotificationsSiteSettingsSection,
});
